















































































































































































































































































































































































































import { defineComponent, ref, useContext, onMounted, useRoute, watchEffect } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import { usePdpStore } from '~/store/pdp'
import { usePDPNavigationObserver } from '~/composables/pdp/usePDPNavigationObserver'
import { COMPONENTS_IN_NAVIGATION } from '@/common/utils/product/constants'
import { filterReferencesForManualCitations, generateReferenceUrl } from '@/common/utils/product/product'
import { useProductStore } from '~/store/product'

export default defineComponent({
  props: {
    confData: {
      type: Object,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
    citationsType: {
      type: String,
      default: '',
    },
    references: {
      type: Array as () => any[],
      default: () => [],
    },
  },
  setup({ confData, productId, citationsType, references }) {
    let response = {} as any
    const mappedReferences = filterReferencesForManualCitations(references)

    const ctx = useContext()
    const route = useRoute()
    const isPreviewServer = ctx.$config.cst.isPreview

    const pdpStore = usePdpStore()
    const productStore = useProductStore()

    const displayCondition = ref(false)
    const isManualCitation = citationsType === 'manual'
    const isCstCitationWidget = confData.cstCitationWidget
    const citationRef = usePDPNavigationObserver(() => {
      pdpStore.setActiveComponentInNavigation(COMPONENTS_IN_NAVIGATION.CITATIONS.ANCHOR)
    })

    const cstCitationData = ref({
      per_page: 5,
      offset: 0,
      totalPages: 0,
      current: 1,
      reactivity: 'all',
      application: 'all',
      number_of_articles: 0,
      total_number_of_articles: 0,
      results: [
        {
          journal: '',
          citation_applications: [] as any,
          pubMedUrl: '',
          title: '',
          author_list: '',
          citation_reactants: [] as any,
          published_year: '',
        },
      ],
      total_results: [] as any,
      applications: [],
      reactants: [],
      defaultLoadLimit: 100,
      preloader: true,
      applicationsCount: 0,
      reactantsCount: 0,
      defaultApplications: [] as any,
      defaultReactants: [] as any,
      disabledApplications: [] as any,
      disabledReactants: [] as any,
      keySelectbox: '',
    })
    const callCitationApi = async (
      params: { limit?: number; offset?: number; application?: string; reactivity?: string },
      hardShow: boolean
    ) => {
      response = await productStore.fetchProductCitationData(productId, {
        limit: params.limit,
        offset: params.offset,
        application: params.application,
        reactants: params.reactivity,
      })

      if (response?.count && response?.citations) {
        const count = response.count.total
        const totalPages = Math.ceil(count / cstCitationData.value.per_page)

        for (let i = 0; i < response.citations.length; i++) {
          const firstAuthor = response.citations[i].author_list.split(',')
          response.citations[i].author_list = firstAuthor[0] + ', et. al.'
          response.citations[i].pubMedUrl = 'https://www.ncbi.nlm.nih.gov/pubmed/' + response.citations[i].pubmedid

          if (response.citations[i].title.length > 120) {
            response.citations[i].title = response.citations[i].title.substr(0, 120) + '...'
          }
        }

        for (let l = 0; l < response.citations.length; l++) {
          cstCitationData.value.total_results.push(response.citations[l])
        }

        cstCitationData.value.total_results = response.citations
        if (cstCitationData.value.offset > cstCitationData.value.total_results.length) {
          cstCitationData.value.results = response.citations.slice(
            cstCitationData.value.total_results.length - cstCitationData.value.per_page * cstCitationData.value.current,
            cstCitationData.value.per_page
          )
        } else {
          cstCitationData.value.results = response.citations.slice(
            cstCitationData.value.offset,
            cstCitationData.value.per_page
          )
        }

        if (isEmpty(cstCitationData.value.results)) {
          cstCitationData.value.results = response.citations.slice(0, cstCitationData.value.per_page)
        }

        if (response.count !== 'undefined') {
          cstCitationData.value.applications = response.count.applications
          cstCitationData.value.reactants = response.count.reactants

          if (cstCitationData.value.keySelectbox === '') {
            cstCitationData.value.applicationsCount = Object.keys(cstCitationData.value.applications).length
            cstCitationData.value.disabledApplications = Object.keys(cstCitationData.value.applications)
            cstCitationData.value.disabledReactants = Object.keys(cstCitationData.value.reactants)
            cstCitationData.value.reactantsCount = Object.keys(cstCitationData.value.reactants).length
          }

          if (isEmpty(cstCitationData.value.defaultApplications) || cstCitationData.value.keySelectbox === '') {
            cstCitationData.value.defaultApplications = cstCitationData.value.applications
          } else if (cstCitationData.value.keySelectbox === 'reactants') {
            if (cstCitationData.value.application === 'all') {
              cstCitationData.value.applicationsCount = Object.keys(cstCitationData.value.applications).length
              cstCitationData.value.disabledApplications = Object.keys(cstCitationData.value.applications)
              const keys = Object.keys(cstCitationData.value.defaultApplications)
              for (let cd = 0; cd < keys.length; cd++) {
                cstCitationData.value.defaultApplications[keys[cd]] = 0
              }
              for (let c = 0; c < cstCitationData.value.disabledApplications.length; c++) {
                cstCitationData.value.defaultApplications[cstCitationData.value.disabledApplications[c]] =
                  cstCitationData.value.applications[cstCitationData.value.disabledApplications[c]]
              }
            }
          }

          if (isEmpty(cstCitationData.value.defaultReactants) || cstCitationData.value.keySelectbox === '') {
            cstCitationData.value.defaultReactants = cstCitationData.value.reactants
          } else if (cstCitationData.value.keySelectbox === 'application') {
            if (cstCitationData.value.reactivity === 'all') {
              cstCitationData.value.disabledReactants = Object.keys(cstCitationData.value.reactants)
              cstCitationData.value.reactantsCount = Object.keys(cstCitationData.value.reactants).length

              const keys = Object.keys(cstCitationData.value.defaultReactants)
              for (let dc = 0; dc < keys.length; dc++) {
                cstCitationData.value.defaultReactants[keys[dc]] = 0
              }
              for (let d = 0; d < cstCitationData.value.disabledReactants.length; d++) {
                cstCitationData.value.defaultReactants[cstCitationData.value.disabledReactants[d]] =
                  cstCitationData.value.reactants[cstCitationData.value.disabledReactants[d]]
              }
            }
          }

          cstCitationData.value.number_of_articles = response.count.total
          cstCitationData.value.totalPages = totalPages

          if (cstCitationData.value.total_number_of_articles === 0) {
            cstCitationData.value.total_number_of_articles = count
          }
        }

        if (hardShow === true) {
          cstCitationData.value.results = response.citations
        }

        cstCitationData.value.preloader = false
        pdpStore.citationsCount = cstCitationData.value.total_number_of_articles

        if (cstCitationData.value.total_number_of_articles) {
          displayCondition.value = true
          pdpStore.setComponentAsRendered(COMPONENTS_IN_NAVIGATION.CITATIONS)
        }
      }
    }
    const setPerPage = () => {
      cstCitationData.value.preloader = true
      if (cstCitationData.value.current === cstCitationData.value.totalPages) {
        cstCitationData.value.offset = cstCitationData.value.number_of_articles - cstCitationData.value.per_page
      }
      const show = cstCitationData.value.total_results.slice(
        cstCitationData.value.offset,
        cstCitationData.value.per_page
      ).length
      if (
        (show < cstCitationData.value.per_page &&
          cstCitationData.value.offset * cstCitationData.value.per_page < cstCitationData.value.number_of_articles) ||
        cstCitationData.value.current === cstCitationData.value.totalPages
      ) {
        const postData = {
          limit: cstCitationData.value.per_page,
          offset: cstCitationData.value.offset,
          application: cstCitationData.value.application === 'all' ? '' : cstCitationData.value.application,
          reactivity: cstCitationData.value.reactivity === 'all' ? '' : cstCitationData.value.reactivity,
        }

        callCitationApi(postData, true)
        cstCitationData.value.current = Math.ceil(cstCitationData.value.offset / cstCitationData.value.per_page)

        if (cstCitationData.value.current === 0) {
          cstCitationData.value.current = 1
        }
      } else {
        cstCitationData.value.results = cstCitationData.value.total_results.slice(
          cstCitationData.value.offset,
          cstCitationData.value.per_page
        )
        if (isEmpty(cstCitationData.value.results)) {
          cstCitationData.value.results = cstCitationData.value.total_results.slice(0, cstCitationData.value.per_page)
        }
        const count = cstCitationData.value.number_of_articles
        cstCitationData.value.totalPages = Math.ceil(count / cstCitationData.value.per_page)
        if (cstCitationData.value.offset === 0) {
          cstCitationData.value.current = 1
        } else {
          cstCitationData.value.current = Math.ceil(cstCitationData.value.offset / cstCitationData.value.per_page)
          if (cstCitationData.value.current === 0) {
            cstCitationData.value.current = 1
          }
        }
        cstCitationData.value.preloader = false
      }
      // scrollToElement();
    }
    const filterApplication = () => {
      // if cstCitationData.value.application selection changes, reset cstCitationData.value.reactivity
      if (cstCitationData.value.reactivity !== 'all' && cstCitationData.value.keySelectbox === 'application') {
        cstCitationData.value.reactivity = 'all'
      }
      filter()
    }
    const filterReactants = () => {
      // if cstCitationData.value.reactivity selection changes, reset cstCitationData.value.application
      if (cstCitationData.value.application !== 'all' && cstCitationData.value.keySelectbox === 'reactants') {
        cstCitationData.value.application = 'all'
      }
      filter()
    }
    const filter = () => {
      setPrimarySelectbox()
      cstCitationData.value.preloader = true
      cstCitationData.value.offset = 0
      cstCitationData.value.current = 1
      const postData = {
        limit: cstCitationData.value.per_page,
        offset: cstCitationData.value.offset,
        application: cstCitationData.value.application === 'all' ? '' : cstCitationData.value.application,
        reactivity: cstCitationData.value.reactivity === 'all' ? '' : cstCitationData.value.reactivity,
      }

      // record UI filter event in Google Analytics
      // trackingFilter();

      callCitationApi(postData, false)
    }
    const previousPage = () => {
      if (cstCitationData.value.current !== 1) {
        cstCitationData.value.preloader = true
        cstCitationData.value.current--
        cstCitationData.value.offset = cstCitationData.value.offset - cstCitationData.value.per_page
        const beginPaginator =
          cstCitationData.value.offset -
          (cstCitationData.value.current * cstCitationData.value.per_page + cstCitationData.value.defaultLoadLimit)
        if (beginPaginator < 0 || beginPaginator > cstCitationData.value.total_results.length) {
          const postData = {
            limit: cstCitationData.value.per_page,
            offset: cstCitationData.value.offset,
            application: cstCitationData.value.application === 'all' ? '' : cstCitationData.value.application,
            reactivity: cstCitationData.value.reactivity === 'all' ? '' : cstCitationData.value.reactivity,
          }

          callCitationApi(postData, true)
        } else {
          const pp = cstCitationData.value.offset + cstCitationData.value.per_page
          cstCitationData.value.results = cstCitationData.value.total_results.slice(cstCitationData.value.offset, pp)
          cstCitationData.value.preloader = false
        }
        // scrollToElement();
      }
    }
    const nextPage = () => {
      if (cstCitationData.value.current < cstCitationData.value.totalPages) {
        cstCitationData.value.preloader = true
        cstCitationData.value.current++
        cstCitationData.value.offset = cstCitationData.value.offset + cstCitationData.value.per_page

        if (
          cstCitationData.value.total_number_of_articles > 50 &&
          cstCitationData.value.offset + 50 > cstCitationData.value.total_results.length
        ) {
          const postData = {
            limit: cstCitationData.value.defaultLoadLimit,
            offset: cstCitationData.value.offset,
            application: cstCitationData.value.application === 'all' ? '' : cstCitationData.value.application,
            reactivity: cstCitationData.value.reactivity === 'all' ? '' : cstCitationData.value.reactivity,
          }

          callCitationApi(postData, false)
        } else if (
          cstCitationData.value.total_number_of_articles <= 50 &&
          cstCitationData.value.total_number_of_articles < cstCitationData.value.total_results.length
        ) {
          const postData = {
            limit: cstCitationData.value.total_number_of_articles,
            offset: 0,
            application: cstCitationData.value.application === 'all' ? '' : cstCitationData.value.application,
            reactivity: cstCitationData.value.reactivity === 'all' ? '' : cstCitationData.value.reactivity,
          }

          callCitationApi(postData, false)
        } else {
          const pp = cstCitationData.value.offset + cstCitationData.value.per_page
          cstCitationData.value.results = cstCitationData.value.total_results.slice(cstCitationData.value.offset, pp)
          cstCitationData.value.preloader = false
        }
        // scrollToElement();
      }
    }
    const firstPage = () => {
      if (cstCitationData.value.current !== 1) {
        cstCitationData.value.preloader = true
        cstCitationData.value.current = 1
        cstCitationData.value.offset = 0

        const postData = {
          limit: cstCitationData.value.defaultLoadLimit,
          offset: cstCitationData.value.offset,
          application: cstCitationData.value.application === 'all' ? '' : cstCitationData.value.application,
          reactivity: cstCitationData.value.reactivity === 'all' ? '' : cstCitationData.value.reactivity,
        }

        callCitationApi(postData, false)
        // scrollToElement();
      }
    }
    const lastPage = () => {
      if (cstCitationData.value.current !== cstCitationData.value.totalPages) {
        cstCitationData.value.preloader = true
        cstCitationData.value.current = cstCitationData.value.totalPages
        cstCitationData.value.offset =
          cstCitationData.value.totalPages * cstCitationData.value.per_page - cstCitationData.value.per_page
        const results = cstCitationData.value.total_results.slice(
          cstCitationData.value.offset,
          cstCitationData.value.per_page
        )
        if (isEmpty(results)) {
          const postData = {
            limit: cstCitationData.value.per_page,
            offset: cstCitationData.value.offset,
            application: cstCitationData.value.application === 'all' ? '' : cstCitationData.value.application,
            reactivity: cstCitationData.value.reactivity === 'all' ? '' : cstCitationData.value.reactivity,
          }

          callCitationApi(postData, false)
        } else {
          cstCitationData.value.preloader = false
        }
        // scrollToElement();
      }
    }
    const clearFilter = () => {
      cstCitationData.value.preloader = true
      cstCitationData.value.current = 1
      cstCitationData.value.offset = 0
      cstCitationData.value.per_page = 5
      cstCitationData.value.reactivity = 'all'
      cstCitationData.value.application = 'all'
      cstCitationData.value.keySelectbox = ''
      // trackingFilter();
      callCitationApi(
        {
          limit: 100,
          offset: 0,
        },
        false
      )
    }
    const setPrimarySelectbox = () => {
      if (cstCitationData.value.application === 'all' && cstCitationData.value.reactivity === 'all') {
        cstCitationData.value.keySelectbox = ''
      } else if (cstCitationData.value.application !== 'all' && cstCitationData.value.keySelectbox === '') {
        cstCitationData.value.keySelectbox = 'application'
      } else if (cstCitationData.value.reactivity !== 'all' && cstCitationData.value.keySelectbox === '') {
        cstCitationData.value.keySelectbox = 'reactants'
      } else if (cstCitationData.value.keySelectbox === 'application' && cstCitationData.value.application === 'all') {
        clearFilter()
      } else if (cstCitationData.value.keySelectbox === 'reactants' && cstCitationData.value.reactivity === 'all') {
        clearFilter()
      }
    }

    if (isManualCitation && !isEmpty(mappedReferences)) {
      pdpStore.citationsCount = mappedReferences.length
      displayCondition.value = true
      pdpStore.setComponentAsRendered(COMPONENTS_IN_NAVIGATION.CITATIONS)
    }

    onMounted(() => {
      if (isCstCitationWidget && !isManualCitation) {
        callCitationApi({}, false)
      }
    })

    watchEffect(() => {
      if (process.client && displayCondition.value && route.value.hash.toLowerCase() === '#citations') {
        document.querySelector('#citations')?.scrollIntoView()
      }
    })

    return {
      displayCondition,
      citationRef,
      isManualCitation,
      cstCitationData,
      isCstCitationWidget,
      setPerPage,
      filterApplication,
      filterReactants,
      filter,
      previousPage,
      nextPage,
      firstPage,
      lastPage,
      clearFilter,
      setPrimarySelectbox,
      generateReferenceUrl,
      pdpStore,
      mappedReferences,
      isPreviewServer,
    }
  },
})
